import { render, staticRenderFns } from "./CarouselInformation.vue?vue&type=template&id=52355eff&scoped=true"
import script from "./CarouselInformation.vue?vue&type=script&lang=js"
export * from "./CarouselInformation.vue?vue&type=script&lang=js"
import style0 from "./CarouselInformation.vue?vue&type=style&index=0&id=52355eff&prod&lang=stylus&scoped=true"
import style1 from "./CarouselInformation.vue?vue&type=style&index=1&id=52355eff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52355eff",
  null
  
)

export default component.exports